import React, {useEffect} from 'react';
import * as S from './HeaderContainer.styles';
// import Header from '../Header/Header';
import OfferSlider from '../OfferSlider/OfferSlider';
import logoBlue from '../../assets/MyPartnerLogo-blue.png';
import logo from '../../assets/MyPartnerLogo.png';

import useWindowSize from '../../../../../../../hooks/use-window-size/src/use-window-size';
import {offerSliderData} from '../Faqs/faqData';
import TextRenderer from '../TextRenderer';

const HeaderContainer = ({isSticky, header}) => {
  const {title, heading, subHeading, heroPeriod, sliderInfo = []} = header || {};
  let firstPart, boldPart;

  const winSize = useWindowSize();
  function handleKnowMore() {
    window.open('https://www.makemytrip.com/promos/mypartner-hero2-programme-01112022.html');
  }

  return (
    <S.HeaderCont>
      {/* {
        winSize.width < 768 &&
        <S.Hamburger>
          <span />
          <span />
          <span />
        </S.Hamburger>
      } */}
      {/* <Header
        logo={isSticky ? logoBlue : logo}
        preferedBy="5,000+ Travel Agents "
        isSticky={isSticky}
      /> */}
      <S.HeaderContDtl>
        <S.HeaderContDtlLeft>
          <S.HeaderContHeading>{title}</S.HeaderContHeading>
          <S.HeaderContSubHeading>{heading}</S.HeaderContSubHeading>
          <S.HeaderContDesc>
            <TextRenderer data={subHeading} />
          </S.HeaderContDesc>
          <S.HeaderContDescDate>{heroPeriod}</S.HeaderContDescDate>
        </S.HeaderContDtlLeft>
        <S.HeaderContDtlRight>
          <OfferSlider data={sliderInfo} />
        </S.HeaderContDtlRight>
      </S.HeaderContDtl>
    </S.HeaderCont>
  );
};

export default HeaderContainer;
